// extracted by mini-css-extract-plugin
export default {"toast":"dHBg8","line":"zHlDU","inner":"VT35B","main":"_hQvW","text":"jgBp4","success":"ROZ5E"};